import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addBpMeasurementApi, listOfBpMeasurementApi, updateBpMeasurementApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../config/constant";
export const BPTypes = () => {
    const { Option } = Select;
    const [bpTypes, setBpTypes] = useState('')

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [BpTypesData, setBpTypesData] = useState()
    const [editBpTypesRecord, setEditBpTypesRecord] = useState()
    const [loading, setLoading] = useState(false)


    // get the list of alll available plans 
    const getListOfBpTypes = () => {
        setLoading(true)

        listOfBpMeasurementApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    const editBpTypes = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'bp_detail': data.name })
        form.setFieldsValue({ 'bp_types': data.tagType })
        setEditBpTypesRecord(data);
    }

    useEffect(() => {
        getListOfBpTypes()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterBpTypes(BpTypesData);
    }, [BpTypesData]);

    // filter recipe tags
    const filterBpTypes = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 || element.tagType.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe category
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateBpMeasurementApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Bp Types Update successfully",
                    });
                    getListOfBpTypes()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'BP Type',
            dataIndex: 'tagType',
            key: 'tagType',
            render: (text) => <a>{text}</a>,
            filters: [
                { text: "Bp Systolic", value: "Bp Systolic" },
                { text: "Bp Diastolic", value: "Bp Diastolic" },
            ],
            onFilter: (value, record) => record.tagType == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editBpTypes(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Below 120',
            tagType: 'Bp Systolic',
            status: true
        },
        {
            id: '2',
            name: 'Below 80',
            tagType: 'Bp Diastolic',
            status: false
        },
        {
            id: '3',
            name: '120-129',
            tagType: 'Bp Systolic',
            status: true
        },
        {
            id: '4',
            name: '130-139',
            tagType: 'Bp Systolic',
            status: true
        },
        {
            id: '5',
            name: '80-89',
            tagType: 'Bp Diastolic',
            status: true
        },
    ];

    const [form] = Form.useForm();

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.bp_detail,
                "tagType": values.bp_types,
                "status": true
            }
            addBpMeasurementApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'bp_detail': '' })
                        form.setFieldsValue({ 'bp_types': '' })
                        notification.success({
                            message: "Bp Measurement added successfully",
                        });
                        getListOfBpTypes()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.bp_detail,
                "tagType": values.bp_types,
                "status": values.status
            }
            updateBpMeasurementApi(editBpTypesRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Bp Measurement Update successfully",
                        });
                        getListOfBpTypes()
                        form.setFieldsValue({ 'bp_detail': '' })
                        form.setFieldsValue({ 'bp_types': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="BPTypes">
            <Row>
                <Col xl={14}>
                    <Form
                        name="AddBPTypesForm"
                        className="AddBPTypesForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row>
                            <Col xl={8}>
                                <Form.Item
                                    name="bp_types"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select BP Type!",
                                        },
                                    ]}
                                    initialValue=""
                                >
                                    <Select
                                        // value={regType}
                                        onChange={(e) => setBpTypes(e)}
                                    >
                                        <Option value="" disabled hidden>
                                            Select Bp Types
                                        </Option>
                                        <Option value="Bp Systolic">Bp Systolic</Option>
                                        <Option value="Bp Diastolic">Bp Diastolic</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="bp_detail"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Bp details!",
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter Bp details" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={7}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}>
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    {/* <h6>{tagCategory ?  `Total ${tagCategory}` : "Total Tags"  }</h6> */}
                    <h6> Total :  {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Bp Measurement Type"
                        onChange={(e) => { filterBpTypes(e.target.value); setBpTypesData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
